const more = ['calls', 'data', 'sms'];
export const transformToGrouped = (input) => {
  const placeholder = {
    subscriptions: {
      total: 0,
    },
    mpay: {
      total: 0,
    },
    more: {
      total: 0,
    },
  };

  input.reduce((c, i) => {
    if (more.includes(i.metric_group)) {
      c.more.total += i['sum(`value`)'];
    } else {
      c[i.metric_group].total += i['sum(`value`)'];
    }
    return c;
  }, placeholder);

  return {
    results: Object.keys(placeholder).map((v) => ({
      metric_group: v,
      'sum(`value`)': placeholder[v].total,
      month: input[0].month,
      year: input[0].year,
    })),
  };
};
